import React from 'react'
import StaticPage from '../components/StaticPage'

function SupportPage() {
  return (
    <StaticPage title="Support the Website" intro="Help keep the Wingbeat site running">
      <p>
        Wingbeat is run entirely by volunteers and there are no membership fees. The costs of
        hosting the website, maintaining the Witchieknowe weather station, and running the club
        are covered by a few generous members. Here are some easy ways you can help.
      </p>

      <h2>Shop through Amazon</h2>
      <p>
        If you shop on Amazon, you can generate a small commission for the club at no extra cost
        to you by using our Amazon Associates link before you buy. Amazon pays the club a small
        percentage of anything you purchase after clicking through.
      </p>
      <p>
        <a
          href="https://www.amazon.co.uk/?tag=wingbeat-21"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
        >
          Shop on Amazon (supports Wingbeat)
        </a>
      </p>
      <p className="muted">
        The tag in this link tells Amazon to credit the purchase to Wingbeat. You pay the same
        price as always. If the club doesn't have an active Associates account yet, please{' '}
        <a href="/contact">contact us</a> and we'll set one up.
      </p>

      <h2>Donate to the weather station</h2>
      <p>
        The club maintains a Holfuy weather station at Witchieknowe which gives live wind data
        to members. If you'd like to help with the running costs, you can make a voluntary
        donation. Please <a href="/contact">get in touch</a> and we'll let you know how.
      </p>

      <h2>Contribute content</h2>
      <p>
        Share your flight logs, photos, and site updates with the club - every contribution helps
        keep the site useful for other pilots. You can submit flight logs once logged in, or{' '}
        <a href="/contact">email us</a> photos and corrections.
      </p>
    </StaticPage>
  )
}

export default SupportPage
